import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { Box, VStack } from '@chakra-ui/react';
import sanitizeHtml from 'sanitize-html';
import Latex from 'react-latex-next';
import { JsFormConfigContext } from '../../../contexts';
import { JsFieldInspector } from '../../jsFormBase';
/**
 * Component renders "/schemas/jsf-background-information" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TBackgroundInformationFormData.
 */
const BackgroundInformationJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const value = props.formData.value ?? '';
    const parts = useMemo(() => {
        return value
            .split('\n')
            .map((part) => {
            return sanitizeHtml(part);
        })
            .filter(Boolean);
    }, [value]);
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(VStack, { "data-testid": "BackgroundInformationJsField-test", "data-name": props.name, border: '1px solid', borderColor: 'border', borderRadius: '4px', gap: '4px', children: parts.map((part, idx) => (_jsx(Box, { p: '8px', children: _jsx(Latex, { children: part }) }, `Info_${idx}`))) }) }));
};
export const BackgroundInformationJsField = memo(BackgroundInformationJsFieldFC);
//# sourceMappingURL=BackgroundInformation.js.map